<template>
  <el-dialog
    :title="'新增应用'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="160px">
      <el-form-item label="应用名称:" prop="appName">
        <el-input v-model="dataForm.appName" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item  label="交易中心:" prop="orgId">
          <el-select  v-model="dataForm.orgId" placeholder="请选择交易中心"
                           style="display: block;margin-bottom: 0px">
                    <el-option
                            v-for="item in traddingList"
                            :key="item.id"
                            :label="item.orgName"
                            :value="item.id">
                    </el-option>
                </el-select>
      </el-form-item>
      <el-form-item label="内网访问地址:" prop="innerNetInfo">
        <el-input v-model="dataForm.innerNetInfo" placeholder="内网访问地址"></el-input>
      </el-form-item>
      <el-form-item label="外网访问地址:" prop="webInfo">
        <el-input v-model="dataForm.webInfo" placeholder="外网访问地址"></el-input>
      </el-form-item>
      <el-form-item label="网关地址:" prop="webInfo">
        <el-input v-model="dataForm.gatewayInfo" placeholder="网关地址"></el-input>
      </el-form-item>
      <el-form-item label="系统类别:" prop="appGroup">
        <el-select  v-model="dataForm.appGroup" placeholder="请选择系统类别"
                    style="display: block;margin-bottom: 0px">
          <el-option
              v-for="item in systemTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="系统图标:" prop="appLogo">
        <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :name="fileName"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
          <img v-if="dataForm.appLogo" :src="dataForm.appLogo" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
<!--        <el-input v-model="dataForm.appLogo" placeholder="系统图标"></el-input>-->
      </el-form-item>
      <el-form-item label="排序:" prop="sort">
        <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
      </el-form-item>
      <el-form-item label="描述:" prop="remark">
        <el-input type="textarea" v-model="dataForm.remark" placeholder="描述"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
let contextPath = window.SITE_CONFIG.contextPath
if (contextPath == undefined) {
  contextPath = ''
}
  export default {
    data() {
      return {
        visible: false,
        dataForm: {
          id:'',
          appType :'0',
          appName: "",
          enabled: 'true',
          caEnabled: 'false',
          loginPwdEnabled:true,
          innerNetInfo:'',
          webInfo: '',
          remark: '',
          orgId:'',
          appLogo:'',
          sort:'',
          appGroup:'0',
          gatewayInfo:''
        },
        fileName:'file1',
        uploadUrl:contextPath+'/api/uploadpublicFile.do',
        traddingList:[],
        jueSe:[],
        systemTypeList:[],
        rules: {
          appName: [
            {required: true, message: '应用名称不能为空', trigger: 'blur'},
          ]
        }
      }
    },
    methods: {
      resetForm() {
        this.$refs['dataForm'].resetFields();
      },
      init() {
        this.getTraddingList()
        this.dataForm.id = ''
        this.getSystemType()
        this.visible = true
        this.$nextTick(() => {
          this.resetForm()
        })
      },
      //获取系统类别
      getSystemType(){
        this.$http.get(`/getEnumList/12?required=true`).then(({data}) => {
          this.systemTypeList = data
        })
      },
      //logo上传
      handleAvatarSuccess(response, file) {
        if (response && response.filepath ) {
          this.dataForm.appLogo =  response.filepath
        }
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传LOGO图片只能是 JPG 或 PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传LOGO图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 表单提交
      dataFormSubmit() {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return
          }
          this.dataSubmit()
        })
      },
    getTraddingList(){
        this.$http.post('/basic/sysorganization/list', {
            'page':1,
            'rows':2000,
            'filter': {
                actionType: 1,
                internalRoleList: ['2020003','2020002','2020001']
            }
        }).then(({data}) => {
            var list=[{
                id:'',
                orgName:'所有交易中心'
            }]
            if (data) {
                list =list.concat( data.rows)
            }
            this.traddingList = list
        })
    },
      // 表单提交
      dataSubmit() {
        this.$http({
          url: '/auth/application/saveOrUpdateApp',
          method: 'post',
          data: this.dataForm
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .el-select{
    width: 100%;
  }
</style>
